import { Container } from '@mui/material';
import { Section } from 'modules/common/components/Section';
import { Allocations } from 'modules/dashboard/components/Allocations';
import { Assets } from 'modules/dashboard/components/Assets';
import { Audits } from 'modules/dashboard/components/Audits';
import { Bottom } from 'modules/dashboard/components/Bottom';
import { DepositClosedBanner } from 'modules/dashboard/components/Deposit';
import { Header } from 'modules/dashboard/components/Header';
import { Information } from 'modules/dashboard/components/Information';
import { Points } from 'modules/dashboard/components/Points';
import { Rewards } from 'modules/dashboard/components/Rewards';
import { Stats } from 'modules/dashboard/components/Stats';

const HAS_POINTS = false;
const HAS_ALLOCATIONS = false;

export function Dashboard(): JSX.Element {
  return (
    <Section>
      <Container maxWidth="md">
        <Header />
        <Stats />
        <Rewards />
        {HAS_POINTS && <Points />}
        <Assets />
        <DepositClosedBanner />
        {HAS_ALLOCATIONS && <Allocations />}
        <Information />
        <Audits />
        <Bottom />
      </Container>
    </Section>
  );
}
